import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { login, resetPassword, clearResult, clearLoginResult, validateToken, requestPwEmail } from '../action/userActions'
import '../../css/ewLogin.css'
import { Button, Form, Card, Col, Modal, Row, Alert } from 'react-bootstrap'


class ForgotPassword extends Component {
    constructor(props) {
        super(props)
        let hasSpecialChars = { valid: false, desc: 'Has 1 Special Character' }
        let hasNum = { valid: false, desc: 'Has 1 Number' }
        let hasUpperCase = { valid: false, desc: 'Has 1 Uppercase Letter' }
        let has10Chars = { valid: false, desc: 'Has At least 10 Characters' }

        let rules = [hasUpperCase, hasNum, hasSpecialChars, has10Chars]

        this.state = { userName: '', password: '', rules, isNewPassValid: false, isConfirmValid: false }
    }

    isValid(str) {
        return new Promise(res => {
            let hasSpecialChars = { valid: /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(str), desc: 'Has 1 Special Character' }
            let hasNum = { valid: /[0-9]/.test(str), desc: 'Has 1 Number' }
            let hasUpperCase = { valid: /[A-Z]/.test(str), desc: 'Has 1 Uppercase Letter' }
            let has10Chars = { valid: str && str.length >= 8, desc: 'Has At least 10 Characters' }

            let rules = [hasUpperCase, hasNum, hasSpecialChars, has10Chars]

            let isNewPassValid = has10Chars.valid && hasNum.valid && hasSpecialChars.valid && hasUpperCase.valid

            this.setState({ rules, newPassword: str, isNewPassValid }, () => res())

        })

    }

    render() {

        if (!this.props.token) {
            return <div>This link has expired. Please go <a href='/custom/changepassword?mode=request'>here</a> to request another.</div>

        } else

            return <Form hidden={this.props.loading} style={{ margin: '10px' }} onSubmit={(e) => {
                e.preventDefault()
                e.stopPropagation()

                this.props.dispatch(resetPassword({ userName: this.props.user.userName, password: this.state.newPassword }))

            }}>
                <h3> Set New Password </h3>


                <Row className='pwRules'>
                    <ul>
                        {this.state.rules.map(rule => {
                            return (
                                <li style={{ color: rule.valid ? 'black' : 'red' }} >
                                    {rule.desc}
                                </li>
                            )
                        })}
                    </ul>
                </Row>

                <Form.Row>

                    <Form.Group as={Col} controlId="formGridNewPassword">
                        <Form.Label></Form.Label>
                        <Form.Control
                            className='login'
                            ref={newPw => this.newPw = newPw} required={this.props.user.success} defaultValue={this.state.newPassword} isInvalid={!this.state.isNewPassValid} isValid={this.state.isNewPassValid} onChange={((e) => {
                                console.log(e)
                                this.isValid(e.target.value).then(() => {
                                    console.log('here')
                                    this.newPw.focus()
                                })

                            })} type="password" placeholder="New Password" />
                    </Form.Group>


                    <Form.Group as={Col} controlId="formGridNewPasswordConfirm">
                        <Form.Label></Form.Label>
                        <Form.Control
                            className='login'
                            required ref={newPwC => this.newPewC = newPwC} defaultValue={this.state.newPasswordConfirm} isInvalid={!this.state.isConfirmValid} isValid={this.state.isConfirmValid} onChange={((e) => {
                                const isConfirmValid = this.state.newPassword === e.target.value
                                this.setState({ newPasswordConfirm: e.target.value, isConfirmValid }, () => this.newPewC.focus())


                            })} type="password" placeholder="Confirm New Password" />
                    </Form.Group>

                </Form.Row>

                <Button className='loginBtn' style={{ backgroundColor: '#015daa' }} type='submit' disabled={!this.state.isNewPassValid || !this.state.isConfirmValid} hidden={!this.props.user.success}>
                    Change Password
                </Button>
            </Form>
    }
}

const mapStateToProps = state => ({
    user: state.acct.user.loggedInUser,
    loading: state.acct.user.loading,
    pwReslt: state.acct.user.resetPasswordResult,
    pwError: state.acct.user.resetPwError
})

export default withRouter(connect(mapStateToProps)(ForgotPassword))